import { FC } from 'react';
import { Image, ImageFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import styles from './ImageTile.module.scss';

export interface ImageTileProps {
  image: ImageFieldValue;
  title: string;
}

const ImageTile: FC<ImageTileProps> = ({ image, title }) => {
  return (
    <div
      className={classNames(
        'light flex flex-col justify-between rounded-2xl bg-beige-100 p-3 md:p-5',
        styles.imageTile
      )}
    >
      <Image className="m-auto" field={{ src: image.src }} alt={image.alt} loading="lazy" />
      <h3 className="py-2 text-center text-sm text-black md:text-base">{title}</h3>
    </div>
  );
};

export default ImageTile;
